import { pickBy } from 'lodash';

import type { Filters } from '../view/state/selected-filters';

/**
 * Generic function to clean filter values
 */
function cleanFilterValue(value: unknown): boolean {
  if (value === undefined || value === null || value === '') return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (typeof value === 'object' && !Array.isArray(value)) {
    // Check if object is empty or only contains undefined/null values
    const keys = Object.keys(value);
    if (keys.length === 0) return false;
    // Check if all values are undefined/null/empty
    const hasValidValue = keys.some((key) => {
      const val = (value as any)[key];
      return val !== undefined && val !== null && val !== '';
    });
    return hasValidValue;
  }
  return true;
}

/**
 * Cleans filter objects by removing undefined, null, empty strings, empty arrays, and empty objects.
 * Returns a cleaned version of the filters suitable for analytics tracking.
 */
export function cleanFilters(filters: Filters): unknown {
  const cleanedCoreFilters = pickBy(filters.coreFilters, cleanFilterValue);
  const cleanedBatteryFilters = pickBy(
    filters.batteryFilters,
    cleanFilterValue,
  );
  const cleanedPcsFilters = pickBy(filters.pcsFilters, cleanFilterValue);

  const result: any = {};

  // Only include coreFilters if it has content
  if (Object.keys(cleanedCoreFilters).length > 0) {
    result.coreFilters = cleanedCoreFilters;
  }

  // Only include batteryFilters if it has content
  if (Object.keys(cleanedBatteryFilters).length > 0) {
    result.batteryFilters = cleanedBatteryFilters;
  }

  // Only include pcsFilters if it has content
  if (Object.keys(cleanedPcsFilters).length > 0) {
    result.pcsFilters = cleanedPcsFilters;
  }

  return result;
}
